import { useField } from "formik";
import React, { ChangeEvent } from "react";
import { Form } from "react-bootstrap";

type Option = {
    value: string;
    label: string;
};

type CheckboxFieldProps = {
    className?: string;
    name: string;
    options: Option[];
    ariaLabelledBy?: string;
    required?: boolean;
};

const CheckboxField = ({
    className,
    name,
    options,
    ariaLabelledBy,
    required,
}: CheckboxFieldProps): JSX.Element => {
    const [field, meta, helpers] = useField<string[]>(name);
    const isInvalid = !!meta.error;
    const ariaLabel = ariaLabelledBy ? ariaLabelledBy : `notification-help-${name}`;

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            helpers.setValue([...field.value, e.target.value]);
        } else {
            helpers.setValue(field.value.filter((it) => it !== e.target.value));
        }
    };

    return (
        <Form.Group
            className={`position-relative mb-5 ${className || ""}`}
            controlId={name}
        >
            {options.map((it, index) => (
                <div
                    key={it.value}
                    className={`bg-background-grey ${
                        isInvalid ? "is-invalid" : ""
                    } rounded-2 py-2 px-3 ${
                        index !== options.length - 1 ? "mb-3" : ""
                    }`}
                >
                    <Form.Check
                        type="checkbox"
                        id={it.value}
                        label={it.label}
                        value={it.value}
                        checked={field.value.includes(it.value)}
                        onChange={handleChange}
                        isInvalid={isInvalid}
                        aria-labelledby={ariaLabel}
                        aria-describedby={`notification-help-${name}`}
                        required={required}
                    />
                </div>
            ))}
            <Form.Control.Feedback type="invalid" className="position-absolute" id={`notification-help-${name}`} style={{color: 'red'}}>
                {meta.error}
            </Form.Control.Feedback>
        </Form.Group>
    );
};

export default CheckboxField;
